<template>
    <div>
        <h6>Seleccione con quien desea compartir la reunión</h6>
        <b-row>
            <b-col cols="10">
                <app-autocomplete
                    placeholder="Administrativos"
                    :items="administrativeUsers"
                    v-model="watcher"
                    results-prop="namePosition"
                />
            </b-col>
            <b-col cols="1">
                <b-btn variant="primary" @click="addWatcher"
                    ><i class="fa fa-plus" aria-hidden="true"></i
                ></b-btn>
            </b-col>
        </b-row>
        <div v-if="watchers.length">
            <h5>Lista de destinatarios</h5>
            <div v-for="watcher in watchers" :key="watcher.id">
                <b-row>
                    <b-col cols="10">
                        <label
                            >- {{ watcher.name }} ({{
                                watcher.position.name
                            }})</label
                        >
                    </b-col>
                    <b-col cols="2">
                        <b-btn
                            size="sm"
                            variant="danger"
                            @click="removeWatcher(watcher)"
                            ><i class="fa fa-times" aria-hidden="true"></i
                        ></b-btn>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
import AutoComplete from "../../../../UI/Controls/AutocompleteV2/Autocomplete.vue";
import contactsRepository from "../../../../../repositories/contacts.repository.js";
import usersRepository from "../../../../../repositories/users.repository.js";
import { required } from "vuelidate/lib/validators";
export default {
    components: {
        appAutocomplete: AutoComplete
    },

    props: {
        id: {
            type: String,
            required: true
        },
        reportId: {
            required: true
        },
        onSave: {
            type: Function
        }
    },
    data() {
        return {
            watchers: [],
            watcher: "",
            administrativeUsers: []
        };
    },

    validations: {
        watchers: { required }
    },

    methods: {
        loadWatchers() {
            const ur = { ...usersRepository };
            ur.getAdministrativeUsers()
                .then(data => {
                    data.map(item => {
                        const administrativeUser = {
                            ...item,
                            namePosition:
                                item.name + " (" + item.position.name + ")"
                        };
                        this.administrativeUsers.push(administrativeUser);
                    });
                })
                .catch(error => {
                    console.log("AssignWatcherToTheReport", error);
                    toastr.error("No se pudo cargar los administrativos");
                });
        },
        addWatcher() {
            if (this.watcher) {
                this.watchers.push({ ...this.watcher });
                this.watcher = "";
            } else {
                toastr.error("Ingrese el nombre del observador");
            }
        },
        removeWatcher(watcher) {
            const i = this.watchers.indexOf(watcher);
            this.watchers.splice(i, 1);
            toastr.success("Observador eliminado");
        },
        saveWatcher() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                toastr.error("Debe seleccionar los observadores");
                return false;
            }

            const formData = new FormData();
            formData.append("reportId", this.reportId);
            this.watchers.map(item => {
                formData.append("watchers[watchers][]", item.id);
            });
            const cr = { ...contactsRepository };
            cr.assignWatchers(formData)
                .then(data => {
                    if (data.status) {
                        typeof this.onSave === "function" && this.onSave();
                        toastr.success(data.msg);
                    } else {
                        toastr.error(data.msg);
                    }
                })
                .catch(error => {
                    toastr.error("Error al asignar observadores");
                });
        },
        cleanFields() {
            this.watchers = [];
            this.watcher = "";
            this.$nextTick(() => {
                this.$v.$reset();
            });
        }
    },
    created() {
        this.$bus.$on(`${this.id}.save`, this.saveWatcher);
        this.$bus.$on(`${this.id}.clean`, this.cleanFields);
        this.loadWatchers();
    },
    beforeDestroy() {
        this.$bus.$off(`${this.id}.save`);
    }
};
</script>

<style></style>
